import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from "./Layout";
import ProtectedRoute from './routes/ProtectedRoute';
import RegisterPage from './pages/RegisterPage';
import LoginPage from './pages/LoginPage';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Blogs from './pages/Blogs';
import CreateBooking from './components/Booking/CreateBooking';
import MyBookings from './components/Booking/MyBookings';
import PaymentForm from './components/Payment/PaymentForm';
import VerifyOtp from './components/Auth/VerifyOtp';
import ForgotPassword from './components/Auth/ForgotPassword';
import ResetPassword from './components/Auth/ResetPassword';

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/verify-otp" element={<VerifyOtp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/book" element={<CreateBooking />} />
        <Route path="/book/:serviceId" element={<CreateBooking />} />
        <Route path="/payment/:bookingId" element={<PaymentForm />} />
        <Route path="/bookings" element={
          <ProtectedRoute>
            <MyBookings />
          </ProtectedRoute>
        } />
          
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/login" element={<LoginPage />} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" />} />
   </Route>
    </Routes>
  );
}
export default App;
